import { splitLocale } from '../../locale/localeUtils';
/**
 * Legacy Font Size Token Values
 *
 * NOTE: In OpenUI, the medium font size was set to 1rem, but most components used the small
 * font size value (0.875rem). For maintainability, we have just shifted the values to match
 * up better with the Nova implementation.
 */
export const fontSizeTokens = theme => {
  const baseFont = parseFloat(theme.overrides?.fontSizeBase ?? '100%') / 100;
  return {
    /**
     * TODO: `xxxxs` is not a supported token size in the SASDS and should be removed.
     * @deprecated
     */
    xxxxs: `${baseFont * 0.5626}rem`,
    xxxs: `${baseFont * 0.5626}rem`,
    xxs: `${baseFont * 0.625}rem`,
    xs: `${baseFont * 0.6875}rem`,
    s: `${baseFont * 0.75}rem`,
    m: `${baseFont * 0.875}rem`,
    l: `${baseFont * 1}rem`,
    xl: `${baseFont * 1.0625}rem`,
    xxl: `${baseFont * 1.125}rem`,
    xxxl: `${baseFont * 1.25}rem`,
    xxxxl: `${baseFont * 1.5}rem`,
    xxxxxl: `${baseFont * 3}rem`,
    h1: `${baseFont * 1.25}rem`,
    h2: `${baseFont * 1.125}rem`,
    h3: `${baseFont * 1.063}rem`,
    h4: `${baseFont * 1}rem`,
    h5: `${baseFont * 0.875}rem`,
    h6: `${baseFont * 0.75}rem`,
    base: theme.overrides?.fontSizeBase ?? '100%'
  };
};
export const fontSizeTokensNova = (theme, language) => {
  let baseSize = 0.875;
  const scaleRatio = 1.125;

  // Override base size for zh-tw locale so characters show up properly (NOVACOMMONS-7870)
  const {
    lang,
    region
  } = splitLocale(language);
  if (lang === 'zh' && region === 'TW') {
    baseSize = 0.91;
  }
  return {
    /**
     * TODO: `xxxxs` is not a supported token size in the SASDS and should be removed.
     * @deprecated
     */
    xxxxs: `${baseSize / scaleRatio ** 5}rem`,
    xxxs: `${baseSize / scaleRatio ** 4}rem`,
    xxs: `${baseSize / scaleRatio ** 3}rem`,
    xs: `${baseSize / scaleRatio ** 2}rem`,
    s: `${baseSize / scaleRatio}rem`,
    m: `${baseSize}rem`,
    l: `${baseSize * scaleRatio}rem`,
    xl: `${baseSize * scaleRatio ** 2}rem`,
    xxl: `${baseSize * scaleRatio ** 3}rem`,
    xxxl: `${baseSize * scaleRatio ** 4}rem`,
    xxxxl: `${baseSize * scaleRatio ** 5}rem`,
    h1: `${baseSize * scaleRatio ** 4}rem`,
    h2: `${baseSize * scaleRatio ** 3}rem`,
    h3: `${baseSize * scaleRatio ** 2}rem`,
    h4: `${baseSize * scaleRatio}rem`,
    h5: `${baseSize}rem`,
    h6: `${baseSize / scaleRatio}rem`,
    base: theme.overrides?.fontSizeBase ?? '100%'
  };
};
//# sourceMappingURL=fontSize.js.map